export interface ServerStatusState {
	status: string
	msg: string
	loading: boolean
}

export const SET_SERVER_STATUS = "SET_SERVER_STATUS"
export const SET_SERVER_STATUS_LOADING = "SET_SERVER_STATUS_LOADING"

interface SetServerStatusAction {
	type: typeof SET_SERVER_STATUS
	payload: {
		status: string
		msg: string
	}
}

interface SetServerStatusLoadingAction {
	type: typeof SET_SERVER_STATUS_LOADING
	payload: boolean
}

export type ServerStatusActionTypes =
	| SetServerStatusAction
	| SetServerStatusLoadingAction
